import { Component, OnInit } from '@angular/core';
import { VantaAuthService } from '../core/services/vantaAuthService';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  imports: [],
})
export class LogoutComponent implements OnInit {
  public constructor(private readonly authService: VantaAuthService) {}

  public ngOnInit(): void {
    this.authService.logout();
  }
}
